import { EventBusService } from "./eventsService/eventBusService";
import { Pmv3MessageEventService } from "./eventsService/pmv3MessageEventService";

export const buildServices = () => {
  const _pmv3MessageEvent = new Pmv3MessageEventService();
  const _eventBusService = new EventBusService(_pmv3MessageEvent);
  return { eventBusService: _eventBusService };
};
